import request from "@/utils/request";
export function register(data) {
    return request({
        url: "/user/register",
        method: "POST",
        data
    });
}
export function sendSMS(data) {
    return request({
        url: "/user/sendSMS",
        method: "GET",
        params: data
    });
}
export function sendSMSNoAuth(data) {
    return request({
        url: "/user/captcha_send_sms_no_auth",
        method: "POST",
        data
    });
}
export function sendSMSWithAuth(data) {
    return request({
        url: "/user/captcha_send_sms_with_auth",
        method: "POST",
        data
    });
}
export function bindMFA() {
    return request({
        url: "/user/bindMFA",
        method: "GET"
    });
}
export function verifyMFA(data) {
    return request({
        url: "/user/verifyMFA",
        method: "GET",
        params: data
    });
}
export function loginByPassword(data) {
    return request({
        url: "/user/loginByPassword",
        method: "GET",
        params: data
    });
}
export function loginByPhone(data) {
    return request({
        url: "/user/login_by_phone_v2",
        method: "GET",
        params: data
    });
}
export function switchLogin(data) {
    return request({
        url: "user/switchLogin",
        method: "GET",
        params: data
    });
}
export function refreshToken(data) {
    return request({
        url: "/user/refreshToken",
        method: "POST",
        data
    });
}
export function modifySubPassword(data) {
    return request({
        url: "/user/modifySubPassword",
        method: "POST",
        data
    });
}
export function modifyPassword(data) {
    return request({
        url: "/user/modifyPassword",
        method: "POST",
        data
    });
}
export function logout() {
    return request({
        url: "/user/logout",
        method: "GET"
    });
}
